import React from 'react'
import clsx from 'clsx'
import { useNavigate } from 'react-router-dom'

const Breadcrumb = ({
    items = [],
    className = '',

}) => {
  let navigate
  try {
    navigate = useNavigate()
  } catch (error) {
    navigate = null
  }

  const handleItemClick = (item, index) => {
    if (index === items.length - 1) return

    if (item.onClick) {
      item.onClick(item, index)
      return
    }

    if (item.path && navigate) {
      navigate(item.path)
    }
  }

  const isClickable = (item, index) => {
    // Last item is never clickable (current page)
    if (index === items.length - 1) return false

    return !!(item.onClick || item.path)
  }

  return (
    <div className={clsx('flex items-center gap-v3-xs font-inter-variable text-v3-h10 text-v3-black-placeholder pb-v3-xs font-medium !h-7 flex-shrink-0', className)}>
      {items.map((item, index) => {
        const clickable = isClickable(item, index)

        return (
          <React.Fragment key={index}>
            <span
              onClick={() => handleItemClick(item, index)}
              className={clsx(
                clickable && 'cursor-pointer hover:text-v3-purple-primary transition-colors duration-200'
              )}
            >
              {item.label}
            </span>
            {index < items.length - 1 && (
              <span>/</span>
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default Breadcrumb
